import { lazyForPaint } from 'react-loosely-lazy';
import { withAsync } from '../with-async';

export const FeedbackCollector = withAsync({
    loader: lazyForPaint(() => import(/* webpackChunkName: "feedback-collector" */ './hocs')),
    LoadingSkeleton: () => null,
});
